"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
require("./style/login.css");
var react_redux_1 = require("react-redux");
var Authentication = require("../../store/Authentication");
var react_router_1 = require("react-router");
var login = /** @class */ (function (_super) {
    __extends(login, _super);
    function login(props) {
        var _this = _super.call(this, props) || this;
        _this.handleEmailChange = _this.handleEmailChange.bind(_this);
        _this.handlePasswordChange = _this.handlePasswordChange.bind(_this);
        _this.handleSubmit = _this.handleSubmit.bind(_this);
        _this.state = {
            email: '',
            password: '',
            isHideAlert: false,
            waitLoading: false
        };
        return _this;
    }
    login.prototype.handleSubmit = function (e) {
        var _a = this.state, email = _a.email, password = _a.password;
        this.props.requestAuthentication({ email: email, password: password });
        this.setState({
            isHideAlert: true
        });
        e.preventDefault();
    };
    login.prototype.handleEmailChange = function (e) {
        this.setState({
            email: e.target.value
        });
    };
    login.prototype.handlePasswordChange = function (e) {
        this.setState({
            password: e.target.value
        });
    };
    login.prototype.render = function () {
        var _a = this.state, isHideAlert = _a.isHideAlert, waitLoading = _a.waitLoading;
        if (!this.props.isLoading) {
            if (this.props.response != undefined) {
                if (this.props.response.uuid != undefined) {
                    isHideAlert = false;
                    waitLoading = false;
                    return (React.createElement(react_router_1.Redirect, { to: "/" }));
                }
                else {
                    isHideAlert = true;
                    waitLoading = false;
                }
            }
        }
        if (localStorage.getItem('SNA_AUTH')) {
            localStorage.removeItem('SNA_AUTH');
        }
        return (React.createElement("div", { className: "limiter" },
            React.createElement("div", { className: "container-login100" },
                React.createElement("div", { className: "wrap-login100 p-t-50 p-b-90" },
                    React.createElement("form", { className: "login100-form validate-form flex-sb flex-w", onSubmit: this.handleSubmit },
                        React.createElement("span", { className: "login100-form-title mb-5" }, "Login"),
                        React.createElement("div", { className: "wrap-input100 validate-input mb-4" },
                            React.createElement("input", { className: "input100", type: "text", name: "username", id: "username", placeholder: "Username", onChange: this.handleEmailChange }),
                            React.createElement("span", { className: "focus-input100" })),
                        React.createElement("div", { className: "wrap-input100 validate-input mb-4", "data-validate": "Password is required" },
                            React.createElement("input", { className: "input100", type: "password", name: "pass", id: "password", placeholder: "Password", onChange: this.handlePasswordChange }),
                            React.createElement("span", { className: "focus-input100" })),
                        React.createElement("div", { className: "flex-sb-m w-full p-t-3 p-b-24" }),
                        React.createElement("div", { className: "container-login100-form-btn m-t-17" },
                            React.createElement("button", { type: "submit", className: "login100-form-btn", id: "btnAuthication" },
                                React.createElement("div", { className: waitLoading ? 'spinner-border text-light mr-4' : 'spinner-border text-light mr-4 d-none', id: "loadingLogin", role: "status" },
                                    React.createElement("span", { className: "sr-only" }, "Loading...")),
                                " Login")),
                        React.createElement("div", { className: isHideAlert ? 'mt-4' : 'alert-transit mt-4 d-none' },
                            React.createElement("div", { className: "alert alert-danger", role: "alert" }, "Invalid Username or Password")))))));
    };
    return login;
}(React.Component));
exports.default = react_redux_1.connect(function (state) { return state.authentication; }, Authentication.actionCreators)(login);
//# sourceMappingURL=login.js.map